import Image from "../../image";
import Text from "../../text/text";
import ReconstructionSlider from "./reconstruction-slider";

const ReconstructionPanel = () => {
  return (
    <div className="p-[20px]">
      <div className="relative">
        <div className="gradient-border-outer">
          <div className="gradient-border md:flex md:h-[72px]">
            <div className="flex flex-1 mt-[20px] md:mt-[0px] mb-[32px] md:mb-[0px] md:items-center md:m0">
              <ReconstructionSlider/>
            </div>
            <div className="flex items-center justify-between gap-3 md:justify-center">
              <div className="flex gap-2">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReconstructionPanel;
